// shared-types/src/payment/supportedPaymentMethodsOrder.ts
import { IntegrationCategory } from '../integration/types'

/** Item en el JSON integration.supportedPaymentMethods (íconos de medios). */
export interface SupportedPaymentMethodIconRow {
	id: string
	name?: string
	thumbnail?: string
	icon?: string
	[key: string]: unknown
}

/** Parsea supportedPaymentMethods desde fila integration (simple-json / array / string JSON). */
export function parseIntegrationSupportedPaymentMethodsArray(raw: unknown): SupportedPaymentMethodIconRow[] {
	if (raw == null) return []
	if (Array.isArray(raw)) return raw as SupportedPaymentMethodIconRow[]
	if (typeof raw === 'string') {
		try {
			const parsed = JSON.parse(raw)
			return Array.isArray(parsed) ? (parsed as SupportedPaymentMethodIconRow[]) : []
		} catch {
			return []
		}
	}
	return []
}

/**
 * Lista única de medios de pago en el orden canónico:
 * 1) Integraciones PAYMENT_GATEWAY ordenadas por integration.order ASC, providerKey ASC
 * 2) Dentro de cada una, el orden del array integration.supportedPaymentMethods
 * 3) Deduplicación por id conservando la primera aparición
 */
export function flattenSupportedPaymentMethodsFromAccountIntegrations(
	accountIntegrations: Array<{ integration?: { category?: string; order?: number; providerKey?: string; supportedPaymentMethods?: unknown } | null }>
): SupportedPaymentMethodIconRow[] {
	const gateways = (Array.isArray(accountIntegrations) ? accountIntegrations : []).filter(
		(ai) => ai?.integration?.category === IntegrationCategory.PAYMENT_GATEWAY
	)

	gateways.sort((a, b) => {
		const ao = Number(a?.integration?.order ?? 0)
		const bo = Number(b?.integration?.order ?? 0)
		if (ao !== bo) return ao - bo
		const ap = String(a?.integration?.providerKey ?? '')
		const bp = String(b?.integration?.providerKey ?? '')
		return ap.localeCompare(bp)
	})

	const flat = gateways.flatMap((ai) =>
		parseIntegrationSupportedPaymentMethodsArray(ai?.integration?.supportedPaymentMethods)
	)

	const seen = new Set<string>()
	const out: SupportedPaymentMethodIconRow[] = []
	for (const row of flat) {
		const id = row?.id != null ? String(row.id).trim() : ''
		if (!id) continue
		if (seen.has(id)) continue
		seen.add(id)
		out.push(row)
	}
	return out
}
